/** Trang chính sách riêng tư trong game (M3). */
import type { GameController } from '../game-controller.js';
import { stylePanel, useCapNhat } from '../dung-chung.js';

export function ChinhSachRiengTu(props: { controller: GameController }) {
  const { controller } = props;
  useCapNhat(controller);
  const muc = controller.duLieu.chinhSachRiengTu;

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>🔒 Chính sách riêng tư</h3>
      {muc.map((m, i) => (
        <div key={i} style={{ marginBottom: '10px' }}>
          <div style={{ fontWeight: 700, fontSize: '14px' }}>{m.tieuDe}</div>
          <div style={{ fontSize: '13px', opacity: 0.9, whiteSpace: 'pre-line' }}>{m.noiDung}</div>
        </div>
      ))}
      <div style={{ marginTop: '12px', borderTop: '1px solid #8a6a3a', paddingTop: '8px' }}>
        <div style={{ fontWeight: 700, fontSize: '14px', marginBottom: '6px' }}>
          Báo lỗi crash (ẩn danh)
        </div>
        <div style={{ fontSize: '13px', opacity: 0.9, marginBottom: '8px' }}>
          Khi game gặp lỗi, bạn có thể gửi báo cáo ẩn danh (chỉ gồm stack trace, phiên bản game,
          trình duyệt — không có ID người dùng, không dữ liệu hành vi).
        </div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {(['hoi', 'luon', 'khong'] as const).map((cheDo) => (
            <button
              key={cheDo}
              onClick={() => controller.datDongYCrash(cheDo)}
              style={{
                background: controller.docDongYCrash() === cheDo ? '#c98a2e' : 'transparent',
                color: controller.docDongYCrash() === cheDo ? '#1d130a' : '#f5e9d0',
                border: '1px solid #8a6a3a',
                borderRadius: '8px',
                padding: '6px 12px',
                cursor: 'pointer',
                fontWeight: 700,
              }}
            >
              {cheDo === 'hoi' ? 'Hỏi trước khi gửi' : cheDo === 'luon' ? 'Luôn gửi' : 'Không gửi'}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
